import { Analytics, AnalyticsBrowser } from '@segment/analytics-next';

import { CustomDestination } from './Avo';

export class SegmentDestination implements CustomDestination {
  private readonly analytics: Analytics | AnalyticsBrowser;

  constructor(analytics: Analytics | AnalyticsBrowser) {
    this.analytics = analytics;
  }

  public make(): Analytics | AnalyticsBrowser {
    return this.analytics;
  }

  identify(userId: string): void {
    this.analytics.identify(userId, {
      system_event_id: this.generateEventId(),
    });
  }

  logEvent(eventName: string, eventProperties: Record<string, unknown>): void {
    this.analytics.track(eventName, {
      ...eventProperties,
      system_event_id: this.generateEventId(),
    });
  }

  setUserProperties(
    userId: string,
    userProperties: Record<string, unknown>,
  ): void {
    this.analytics.identify(userId, {
      ...userProperties,
      system_event_id: this.generateEventId(),
    });
  }

  unidentify(): void {
    this.analytics.reset();
  }

  logPage(pageName: string, eventProperties: Record<string, unknown>): void {
    this.analytics.page(pageName, {
      ...eventProperties,
      system_event_id: this.generateEventId(),
    });
  }

  private generateEventId(): string {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 20;
    const randomChars: string[] = [];

    for (let i = 0; i < length; i++) {
      randomChars.push(
        characters.charAt(Math.floor(Math.random() * characters.length)),
      );
    }

    const randomString = randomChars.join('');
    const anonymousId = this.getAnonymousId();
    const timestamp = this.formatUTCTimestamp(new Date());

    return `${timestamp}-${anonymousId}-${randomString}`;
  }

  private getAnonymousId(): string {
    if ('instance' in this.analytics) {
      return this.analytics.instance?.user().anonymousId() ?? 'unknown';
    }
    return 'unknown';
  }

  private formatUTCTimestamp(date: Date): string {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0];
  }
}
